import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { LoadingSpinner } from '../Common/LoadingSpinner';

const Style = styled.div`
	width: 30rem;
	height: 20rem;
	overflow: hidden;
	border-radius: 10px;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	.error-message {
		color: #f23722;
		position: absolute;
		top: 35%;
	}

	perspective: 30em;
	background-color: rgba(88, 58, 107, 0.6);

	.message_section {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 2rem !important;
		margin-top: 3rem;
		margin-bottom: 3rem;
		.message_text {
			font-size: 1.8rem;
		}
	}

	.login-card {
		width: 100%;
		height: 100%;
		position: relative;
		transition: transform 0.5s;
		transform-style: preserve-3d;
		&.step-two {
			transform: rotateY(180deg);
		}
	}

	.login-form {
		width: 100%;
		height: 100%;
		color: #fff;
		text-align: center;
		position: absolute;
		backface-visibility: hidden;
		transform: rotateX(0deg);
		&.step-two {
			transform: rotateY(180deg);
		}
		.loading-spinner {
			height: 3rem;
		}
		.input-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			border: 2px solid rgba(88, 58, 107);
			flex: 1;
			.label {
				width: 20%;
				height: 100%;
			}
		}

		input {
			width: 100%;
			height: 4rem;
			padding-left: 1rem;
			color: #ffffff;
			background-color: rgba(88, 58, 107, 0.4);
			border: none;
			border-left: none;
			font-size: 1rem;
			::placeholder {
				color: #ffffff;
			}
		}
		.selection {
			height: 4rem;
		}
		button {
			width: 100%;
			height: 4rem;
			background-color: rgba(88, 58, 107);
			cursor: pointer;
			color: #ffffff;
			font-size: 1.5rem;
			border: none;
		}
		button:disabled {
			opacity: 0.4;
		}
		button:active {
			background-color: rgba(88, 58, 107, 0.5);
		}
	}
	.password-container {
		position: relative;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 40rem;
		height: 23rem;

		.error-message {
			top: 28%;
		}

		perspective: 30em;

		.message_section {
			height: 2rem !important;
			margin-top: 3rem;
			margin-bottom: 3rem;
			.message_text {
				font-size: 1.8rem;
			}
		}

		.login-form {
			.loading-spinner {
				height: 3rem;
			}

			input {
				height: 5rem;
				padding-left: 1rem;

				font-size: 1rem;
			}
			.selection {
				height: 5rem;
			}
			button {
				width: 100%;
				height: 5rem;

				font-size: 1.5rem;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 40rem;
		height: 23rem;

		.error-message {
			top: 28%;
		}

		perspective: 30em;

		.message_section {
			height: 2rem !important;
			margin-top: 3rem;
			margin-bottom: 3rem;
			.message_text {
				font-size: 1.8rem;
			}
		}

		.login-form {
			.loading-spinner {
				height: 3rem;
			}

			input {
				height: 5rem;
				padding-left: 1rem;

				font-size: 1rem;
			}
			.selection {
				height: 5rem;
			}
			button {
				width: 100%;
				height: 5rem;

				font-size: 1.5rem;
			}
		}
	}
`;

export const PasswordContainer = ({
	receiveInput,
	navigate,
	registration_status,
	resetRegistrationState,
}) => {
	const [password, setPassword] = useState('');
	const [countdown, setCountdown] = useState(3);
	const [validInput, setValidInput] = useState(false);
	const [confirmPassword, setConfirmPassword] = useState('');
	const [validationRules, setValidationRules] = useState([
		'Must be at least 8 characters',
		'Must contain at least one number',
		'Must contain at least one capital letter',
		'Must contain at least one special character',
		'Must only contain alphanumeric and special characters',
		'Passwords must match',
	]);
	const [loading, setLoading] = useState(false);
	const status = registration_status?.status;

	function resetPasswordForm() {
		const doc = document.getElementById('login-card');
		resetRegistrationState();
		setLoading(false);
		doc.classList.remove('step-two');
		setPassword('');
		setConfirmPassword('');
	}

	function onClickHandler(e) {
		if (e.key === 'Enter' || e.type === 'click') {
			setLoading(true);
			receiveInput(password, confirmPassword);
		}
	}

	const validateInput = () => {
		const rules = [];
		if (password.length < 8) rules.push('Must be at least 8 characters');
		if (!/\d/.test(password)) rules.push('Must contain at least one number');
		if (!/[A-Z]/.test(password)) rules.push('Must contain at least one capital letter');
		if (password !== confirmPassword || password === '') rules.push('Passwords must match');
		if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
			rules.push('Must contain at least one special character');
		if (!/^[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]+$/.test(password))
			rules.push('Must only contain alphanumeric and special characters');
		setValidationRules(rules);
		setValidInput(rules.length === 0 && password === confirmPassword);
	};

	useEffect(() => {
		validateInput();
	}, [password, confirmPassword]);

	useEffect(() => {
		try {
			const doc = document.getElementById('login-card');
			if (status === 'CONFIRM_PASSWORD_SUCCESS' || status === 'CONFIRM_PASSWORD_ERROR') {
				if (doc && !doc.classList.contains('step-two')) {
					setLoading(false);
					doc.classList.add('step-two');
				}
			}
			if (status === 'CONFIRM_PASSWORD_SUCCESS' || status === 'CONFIRM_PASSWORD_ERROR') {
				const timer = setInterval(() => {
					setCountdown(prevCountdown => prevCountdown - 1);
				}, 1000);

				const redirectTimer = setTimeout(() => {
					status === 'CONFIRM_PASSWORD_SUCCESS' ? navigate('/login') : resetPasswordForm();
				}, 3000);

				return () => {
					clearInterval(timer);
					clearTimeout(redirectTimer);
				};
			}
		} catch (e) {
			console.log('error', e);
		}
	}, [registration_status]);

	return (
		<>
			<Style className='login-container'>
				<div className='message_section'>
					<span data-cy='login-message-text' className='message_text'>
						Customer Portal Password Reset
					</span>
				</div>
				<div className='login-card shadow' id='login-card'>
					<div className='login-form step-one'>
						<div className='input-wrapper'>
							<div className='label body10'>Password</div>
							<input
								id='pwdInput'
								value={password}
								className='body10'
								type='password'
								placeholder='******'
								onChange={e => setPassword(e.target.value)}
							/>
						</div>
						<div className='input-wrapper'>
							<div className='label body10'>Confirm Password</div>
							<input
								id='pwdInput'
								value={confirmPassword}
								className='body10'
								type='password'
								placeholder='******'
								onKeyDown={onClickHandler}
								onChange={e => setConfirmPassword(e.target.value)}
							/>
						</div>
						<div className='d-grid'>
							<button
								id='login-button'
								variant='primary'
								type='submit'
								className='labels21'
								onClick={onClickHandler}
								disabled={loading || !validInput}
							>
								{!loading || status === 'CONFIRM_PASSWORD_ERROR' ? 'Submit' : <LoadingSpinner />}
							</button>
						</div>
					</div>
					<div className='login-form step-two'>
						{status === 'CONFIRM_PASSWORD_SUCCESS' && (
							<div>
								<div className='body10'>Your password has been reset successfully!</div>
								<div className='body10'>
									You will now be redirected to our login page in {countdown} seconds.
								</div>
							</div>
						)}
						{status === 'CONFIRM_PASSWORD_ERROR' && (
							<div>
								<div className='body10'>Whoops there has been an issue updating your password.</div>
								<div className='body10'>You will be able to try again in {countdown} seconds.</div>
							</div>
						)}
					</div>
				</div>
			</Style>
			{validationRules?.length !== 0 && (
				<div className='validation-popup'>
					<ul>
						{validationRules.map(rule => (
							<li className='body10' key={rule}>
								{rule}
							</li>
						))}
					</ul>
				</div>
			)}
		</>
	);
};
